import * as React from "react";
import "./ContactDetailView.scss";
import { Callout } from "office-ui-fabric-react/lib/Callout";
import { Facepile } from "office-ui-fabric-react/lib/Facepile";
// import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import { DirectionalHint } from "office-ui-fabric-react/lib/ContextualMenu";
import { DayOfWeek } from "office-ui-fabric-react/lib/DatePicker";
import { IFacepilePersona } from "office-ui-fabric-react/lib/Facepile";
import {
  IFacepileProps,
  OverflowButtonType
} from "office-ui-fabric-react/lib/Facepile";
//import ReactHtmlParser from 'react-html-parser';
//import HTMLReactParser  from "html-react-parser";
import { Helper } from "../../Utils/Helper";
// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
 export interface IProps {
  contactName: string;
  contactId: string;
  contactlinks:string;
  crmurl: string;
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  DetailCalloutVisible?: boolean;
  firstDayOfWeek?: DayOfWeek;

  //ContactDetails;
}

export default class ContactDetailView extends React.Component<
  IProps,
  IContextualMenuState
> {
  public facepilePersonas: IFacepilePersona[] = [
    {
      //imageUrl:"https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png",
      imageUrl:Helper.GetDefaultImage(),
      personaName: this.props.contactName,
      data: "50%"
    }
  ];
  public facepileProps: IFacepileProps = {
    personas: this.facepilePersonas,
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    showTooltip:false,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
  private _menuButtonElement: HTMLElement | null;
  constructor(props: IProps) {
    super(props);
    this.state = {
      DetailCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      //ContactDetails: null
    };
  }
  public render() {
    const { DetailCalloutVisible, beakWidth } = this.state;

    let rowcss = "ms-Grid-row miparow " + "detailrow";
    let links=this.props.contactlinks;
    //let crmcotnactlink=this.props.crmurl+'/pages/?page=contact&slideno=1&ID='+this.props.contactId;
    let crmcotnactlink =window.GetCRMTeamsDeepLink(this.props.contactId,'contact',1,''); 
    return (
      <div
        style={{ cursor: "pointer" }}
        ref={menuButton => (this._menuButtonElement = menuButton)}
        onClick={this._onMenuClicked}
        //title={this.props.contactName}
        title={'Open the contact in iGlobe CRM ('+this.props.contactName+')'}
        className={["contact", "ellips"].join(" ")}
      >
        {this.props.contactName}
        {DetailCalloutVisible ? (
          <Callout
            className="ms-Callout-callout"
            onDismiss={this._onCalloutDismiss}
            target={this._menuButtonElement}
            directionalHint={DirectionalHint.topAutoEdge}
            coverTarget={false}
            isBeakVisible={true}
            gapSpace={0}
            beakWidth={beakWidth}
          >
            <div className="detailcallout">
              <div className="ms-Callout-inner" style={{ padding: "10px" }}>
                <div className="ms-Callout-content ms-Grid">
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <div className="assignecontainer" title="Open the contact in iGlobe CRM">
                        <a title="Open the contact in iGlobe CRM" href="#"  onClick={()=>{window.NavigateToTeamTab(crmcotnactlink)} }>
                          <Facepile {...this.facepileProps} />
                        </a>
                        
                      </div>
                    </div>
                  </div>

                  <div className={rowcss}>
                  <div
                    className="ms-Grid-col ms-sm12"
                    dangerouslySetInnerHTML={{ __html: links }}
                  />
                    {/* <div className="ms-Grid-col ms-sm12">                      
                     {HTMLReactParser(links)}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </Callout>
        ) : null}
      </div>
    );
  }

  private _onCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {
    // if (this.state.ContactDetails == null) {
    //   /*let detailapi=MIAPACons.GraphAPI.GraphBaseURL+MIAPACons.GraphAPI.TaskDetail.replace('{0}',this.props.data.id)+ Math.round(+new Date() / 1000);                  
    //     GraphRequest.GET(detailapi,this.props.Header,(detail)=>{
            
    //         this.setState({
    //             ContactDetails: detail.data
    //             });
    //     },(error)=>{

    //     },this.props.Progress);
    //     */
    // }
    this.setState({ DetailCalloutVisible: !this.state.DetailCalloutVisible });
  }
  
  /* private rawbody = (links) => {
      // dangerouslySetInnerHTML={this.rawbody(links)}
    var rawMarkup =links;
    return { __html: rawMarkup };
  } */
}

